import { render } from "./DefButtonCross.vue?vue&type=template&id=64a59a1c&scoped=true"
const script = {}

import "./DefButtonCross.vue?vue&type=style&index=0&id=64a59a1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a59a1c"]])

export default __exports__